import type { LoaderFunction } from 'react-router';

import { competenciesSchema } from '~/shared/data-contract/job-profile';
import type { ValidatingHttpFetcherWithBaseUrl } from '~/shared/validating-http-fetcher';

export const createPositionManagementPageLoader = (
    validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl,
): LoaderFunction => {
    return async () => {
        const competencies = await validatingCobrainerApiFetcher.get(competenciesSchema, {
            pathname: '/skills/competencies',
        });

        return {
            competencies,
        };
    };
};
